
import React from "react";

interface PageTitleProps {
  title: React.ReactNode;
  description: string;
  reliabilityLevel?: 1 | 2 | 3 | 4 | 5;
}

export const PageTitle = ({ title, description, reliabilityLevel }: PageTitleProps) => {
  return (
    <header className="mb-6 sm:mb-8">
      {title && (
        <div className="mb-2">
          <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#23486a] leading-snug break-words [overflow-wrap:anywhere]">
            {title}
          </h1>
        </div>
      )}
      {description && (
        <p className="text-muted-foreground text-sm sm:text-base max-w-3xl">{description}</p>
      )}
    </header>
  );
};
